import TaskaShkspr from 'assets/img/taska-shkspr.svg'
import messages from 'i18n/messages'
import first from 'lodash/first'
import flowRight from 'lodash/flowRight'
import Head from 'next/head'
import Link from 'next/link'
import { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Button, Container } from 'reactstrap'

class OrderHasExpired extends Component {

  render () {
    const { intl: { formatMessage }, org, order } = this.props
    const dateId = first(order.event_date_ids)
    return (
      <div className="tt-checkout">
        <Head>
          <title>{`${formatMessage(messages.ticketShop, org)}`}</title>
          <meta name="robots" content="noindex, nofollow" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        </Head>
        <Container className="d-flex justify-content-center">
          <div className="feedback-outer-wrap">
            <div className="feedback-wrap">
              <div className="text-center">
                <h2 className="text-danger"><FormattedMessage {...messages.orderExpired} /></h2>
                <div className="mt-3 mb-5">
                  <Link href={`/${org.odn}/b/${dateId}`}>
                    <Button color="primary">
                      <FormattedMessage {...messages.tryAgain} />
                    </Button>
                  </Link>
                </div>
                <img className="hero-img" src={TaskaShkspr} alt="" />
              </div>
            </div>
          </div>
        </Container>
      </div>
    )
  }
}

const enhance = flowRight(
  injectIntl,
)

export default enhance(OrderHasExpired)
